// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1HL98","header":"ReportDetails_header__PNVvX","title":"ReportDetails_title__3EHZ_","left":"ReportDetails_left__3Blp8"};